// extracted by mini-css-extract-plugin
export default {"paymentSection":"J5-z"};